import { render, staticRenderFns } from "./riskStatus.vue?vue&type=template&id=9bae7694"
import script from "./riskStatus.vue?vue&type=script&lang=js"
export * from "./riskStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9bae7694')) {
      api.createRecord('9bae7694', component.options)
    } else {
      api.reload('9bae7694', component.options)
    }
    module.hot.accept("./riskStatus.vue?vue&type=template&id=9bae7694", function () {
      api.rerender('9bae7694', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/riskStatus.vue"
export default component.exports